import { UserApi } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "../Services/ServiceConfiguration";
import { AuthenticatedUser } from "../Types/AuthenticatedUser";
import { SubscriptionLevel } from "../Types/SubscriptionLevel";

let user: AuthenticatedUser | null = null;

export const AuthProvider = () => {
  const SetUser = async (authenticatedUser: AuthenticatedUser) => {
    user = authenticatedUser;
  };

  const Logout = async () => {
    try {
      await new UserApi(GetApiConfiguration()).apiUserLogoutPost();
    }
    catch {
      // Always continue with local logout cleanup even if backend logout fails
    }

    user = null;
  };

  const GetLoggedInUser = (refresh?: boolean): Promise<AuthenticatedUser | null> => {
    if (user && !refresh) {
      return Promise.resolve(user);
    }

    // Always try the API — the HttpOnly cookie is the source of truth
    return new UserApi(GetApiConfiguration()).apiUserGetLoggedInUserGet().then(response => {
      user = {
        id: response.id ? response.id : "",
        companyId: response.companyId ? response.companyId : -1,
        firstName: response.firstName ? response.firstName : "",
        lastName: response.lastName ? response.lastName : "",
        email: response.email ? response.email : "",
        companyLanguage: response.companyLanguage,
        subscriptionLevel: response.subscriptionLevel ? response.subscriptionLevel as SubscriptionLevel : SubscriptionLevel.Free,
        hasPaidSubscription: response.hasPaidSubscription,
        role: response.role,
        companyType: response.companyType,
        paymentConfiguration: response.paymentConfiguration,
        familyMemberConfiguration: response.familyMemberConfiguration,
        hasOnlyReadRights: response.hasOnlyReadRights,
        maxAdministrators: response.maxAdministrators,
        maxReadAdministrators: response.maxReadAdministrators,
        maxEmails: response.maxEmails,
        maxMembers: response.maxMembers,
        smsCredits: response.smsCredits,
        companyName: response.companyName ? response.companyName : ""

      } as AuthenticatedUser;

      return user;
    }).catch(() => {
      user = null;
      return null;
    });
  };

  const ValidateUserLogin = async () => {
    const userLoggedIn = await GetLoggedInUser();
    if (userLoggedIn === null) {
      window.location.href = "/Login?redirect=" + window.location.pathname;
    }
  }

  return {
    SetUser,
    GetLoggedInUser,
    Logout,
    ValidateUserLogin
  };
};